var map = {
	"./arrow_down.svg": [
		722457,
		22457
	],
	"./arrow_left.svg": [
		180290,
		80290
	],
	"./arrow_right.svg": [
		227641,
		27641
	],
	"./arrow_up.svg": [
		141270,
		41270
	],
	"./audio.svg": [
		988703,
		88703
	],
	"./blocked.svg": [
		828997,
		28997
	],
	"./check.svg": [
		737537,
		37537
	],
	"./close.svg": [
		384637,
		84637
	],
	"./close_outline.svg": [
		48834,
		48834
	],
	"./closedcaptioning.svg": [
		115805,
		15805
	],
	"./exit.svg": [
		610459,
		10459
	],
	"./help.svg": [
		798242,
		98242
	],
	"./mic.svg": [
		569788,
		69788
	],
	"./more_horizontal.svg": [
		382775,
		82775
	],
	"./more_vertical.svg": [
		562885,
		62885
	],
	"./navigate_down.svg": [
		299257,
		99257
	],
	"./navigate_left.svg": [
		214562,
		14562
	],
	"./navigate_right.svg": [
		636057,
		36057
	],
	"./navigate_up.svg": [
		303798,
		3798
	],
	"./pause.svg": [
		47947,
		47947
	],
	"./play_down.svg": [
		627876,
		27876
	],
	"./play_left.svg": [
		521155,
		43536
	],
	"./play_right.svg": [
		20646,
		20646
	],
	"./play_up.svg": [
		983295,
		83295
	],
	"./practice.svg": [
		428284,
		28284
	],
	"./redo.svg": [
		530935,
		30935
	],
	"./select.svg": [
		73299,
		73299
	],
	"./settings.svg": [
		346220,
		46220
	],
	"./skip_backward.svg": [
		632850,
		32850
	],
	"./skip_forward.svg": [
		278664,
		78664
	],
	"./speaker_playing.svg": [
		280285,
		80285
	],
	"./star.svg": [
		961999,
		61999
	],
	"./time.svg": [
		241176,
		41176
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 795563;
module.exports = webpackAsyncContext;